import { useEffect, useState } from "react";

const TOKEN_KEY = "access_token";

export function useToken() {
  const [token, setTokenState] = useState<string | null>(null);

  useEffect(() => {
    const storedToken = localStorage.getItem(TOKEN_KEY);
    setTokenState(storedToken);
  }, [TOKEN_KEY]);

  const saveToken = (newToken: string) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setTokenState(newToken);
  };

  const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    setTokenState(null);
  };

  return {
    token,
    saveToken,
    removeToken,
  };
}